const styles = {
  popover: {
    maxHeight: 600,
  },
};

export default styles;
